commusoftCommon.filter('dateFormat', function() {
    return function(dateString) {
        return moment(dateString).format('ddd Do MMM YYYY [at] HH:mm')
    };
});